export default "__VITE_ASSET__DASrlmY7__"